<template>
    <div class="card">
        <div v-if="!submitted">
            <b-form @submit.stop.prevent="saveDrivingLicense">
                <b-form-group id="name" label="Nome" label-for="name" description="">
                    <b-form-input v-model="drivingLicense.name"
                                  placeholder=""
                                  :state="validateState('name')"
                                  aria-describedby="name-live-feedback"></b-form-input>
                    <b-form-invalid-feedback
                        id="name-live-feedback"
                    >Questo campo è obbligatorio.</b-form-invalid-feedback>
                </b-form-group>
            </b-form>

            <div class="action-bar row">
                <div class="col-sm-8">
                    <button class="btn btn-success " @click="saveDrivingLicense" :disabled="this.$store.state.loading"><b-icon icon="file-earmark-check"/> Salva</button>
                </div>
                <div class="col-sm-4 text-right">

                </div>
            </div>
            <div>
                <br>
                <b-alert variant="success" :show="message != ''" fade><b-icon icon="hand-thumbs-up"/> {{ message }}</b-alert>
                <b-alert variant="danger" :show="errorMsg != ''">{{ errorMsg }}</b-alert>
            </div>
        </div>

    </div>
</template>

<script>
import DrivingLicenseDataService from "./DrivingLicenseDataService";
import {required} from 'vuelidate/lib/validators'

export default {
    name: "driving-license-create",
    data() {
        return {
            drivingLicense: {
                id: null,
                name: ''
            },
            submitted: false,
            message: '',
            errorMsg: '',
        };
    },
    validations: {
        drivingLicense: {
            name: {
                required,
            }
        }
    },
    methods: {
        validateState(name) {
            const { $dirty, $error } = this.$v.drivingLicense[name];
            return $dirty ? !$error : null;
        },
        saveDrivingLicense() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.submitted = false;
            } else {
                DrivingLicenseDataService.create(this.drivingLicense)
                    .then(response => {
                        this.drivingLicense.id = response.data.id;
                        this.submitted = true;
                        this.$emit('created-driving-license');
                    })
                    .catch(e => {
                        this.errorMsg = 'Non hai compilato tutti i campi';
                        console.log(e);
                    });
            }
        },

        closeEditor() {
            this.$emit('closed-editor');
        },
    }
};
</script>

<style>
.submit-form {
    max-width: 300px;
    margin: auto;
}
</style>
